import React from 'react';
import Input from '@material-ui/core/Input';
import InteractiveHint from 'components/InteractiveHint';
import { InfoCircle } from 'assets/icons'
import { FormInputFieldContainer, InputFieldContainerProps } from './style';

type MaterialUiInput = React.ComponentProps<typeof Input>;

type InputFieldProps = {
  className?: string,
  label?: string;
  highLightLabel?: string;
  labelWeight?: string;
  labelSize?: string;
  inputFontSize?: string;
  inputFontWeight?: string;
  inputBackgroundColor?: string;
  iconUrl?: string;
  iconHint?: Pick<React.ComponentProps<typeof InteractiveHint>, 'title' | 'content'>;
  iconWidth?: number;
  iconHeight?: number;
  iconRight?: number;
  iconTop?: number;
  errorMessage?: string;
  success?: boolean;
  successMessage?: string;
  isRequired?: boolean;
  maxLength?: number;
  infoIcon?: boolean;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  list?: string;
  placeholderFontSize?: string;
  placeholderColor?: string;
  innerLabel?: string;
} & InputFieldContainerProps &
  MaterialUiInput;

const FormInputField: React.FC<InputFieldProps> = ({
  className,
  highLightLabel,
  label,
  width,
  marginBottom,
  iconUrl,
  iconHint,
  iconWidth,
  iconHeight,
  iconRight,
  iconTop,
  inputBackgroundColor,
  isRequired,
  maxLength,
  infoIcon,
  onMouseOver,
  onMouseOut,
  list,
  innerLabel,
  ...layout
}) => {

  return (
    <FormInputFieldContainer
      className={className}
      $hasInnerLabel={!!innerLabel}
      placeholderFontSize={layout.placeholderFontSize}
      placeholderColor={layout.placeholderColor}
      labelPosition={layout.labelPosition}
      labelColor={layout.labelColor}
      labelSize={layout.labelSize}
      labelWeight={layout.labelWeight}
      borderColor={layout.borderColor}
      inputHeight={layout.inputHeight}
      inputTextColor={layout.inputTextColor}
      inputFontSize={layout.inputFontSize}
      inputFontWeight={layout.inputFontWeight}
      inputBackgroundColor={inputBackgroundColor}
      error={layout.error}
      success={layout.success}
      width={width}
      marginBottom={marginBottom}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      iconRight={iconRight}
      iconTop={iconTop}
    >
      {label?
        <label>
          <span className="highLight">{highLightLabel}</span>
          <span>{label}</span>
          {isRequired? <span className="required"> *</span>: null}
          {infoIcon? <span className="infoIconHolder" onMouseOver={onMouseOver} onMouseOut={onMouseOut}><InfoCircle className="infoIcon"></InfoCircle></span>: null}
        </label>
      : null}
      {(iconUrl && iconUrl.length > 0)? (
        iconHint ? (
          <span className="icon iconWithHint">
            <InteractiveHint {...iconHint}>
              <img src={iconUrl} alt={typeof iconHint.title === 'string' ? iconHint.title : ''} />
            </InteractiveHint>
          </span>
        ) : <img src={iconUrl} className="icon" alt="check"/>
      ) : null}
      <div className="inputWrapper">
        {innerLabel && (
          <span className="innerLabel">
            {innerLabel}
          </span>
        )}

        <Input
          disableUnderline
          fullWidth={true}
          value={layout.value || ''}
          inputProps={{
            maxLength,
            list,
            'aria-label': innerLabel || label || undefined,
          }}
          type={layout.type}
          autoComplete={layout.autoComplete}
          onChange={layout.onChange}
          onBlur={layout.onBlur}
          onFocus={layout.onFocus}
          onKeyDown={layout.onKeyDown}
          inputComponent={layout.inputComponent}
          inputRef={layout.inputRef}
          placeholder={layout.placeholder}
          disabled={layout.disabled}
        />
      </div>
      {layout.error? <div className="warning">{layout.errorMessage?.length? layout.errorMessage: 'This field is required.'}</div>: null}
      {layout.success? <div className="success">{layout.successMessage?.length? layout.successMessage: 'Success!'}</div>: null}
    </FormInputFieldContainer>
  );
};

export default FormInputField;